import { render, staticRenderFns } from "./DwzcsqEdit.vue?vue&type=template&id=efd84458&scoped=true"
import script from "./DwzcsqEdit.vue?vue&type=script&lang=js"
export * from "./DwzcsqEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd84458",
  null
  
)

export default component.exports